export class EquipamentosModel {
  id_equipamento: number;
  descricao: string;
  calibracao: string;
  vencimento: string;
  numero_serie: string;
}



// WEBPACK FOOTER //
// ./src/app/equipamentos/equipamentos.model.ts